export default {"src":"/_next/static/media/Logo-AI.7eea6b83.svg","height":39,"width":251,"blurWidth":0,"blurHeight":0};